import { CodigoEquipoModel } from '@/store/catalogos/codigoEquipo';
import { Colaborador } from '@/store/catalogos/colaborador';
import { DepartamentoModel } from '@/store/catalogos/departamento';
import { EquipoModel } from '@/store/catalogos/equipo';
import { MarcaModel } from '@/store/catalogos/marcas';
import { ProveedorModel } from '@/store/catalogos/proveedor';
import { properties } from '@/utils/properties';
import { Util } from '@/utils/util';
import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormularioProveedorComponent } from '@modules/catalogos/proveedor/formulario-proveedor/formulario-proveedor.component';
import { CatalogoCodigoEquipoService } from '@services/catalogo/catalogoCodigoEquipo.service';
import { CatalogoColaboradorService } from '@services/catalogo/catalogoColaborador.service';
import { CatalogoDepartamentoService } from '@services/catalogo/catalogoDepartamento.service';
import { CatalogoMarcaService } from '@services/catalogo/catalogoMarca.service';
import { CatalogoProveedorService } from '@services/catalogo/catalogoProveedor.service';
import { EquipoPatronService } from '@services/catalogo/equipoPatron.service';
import { ValidatorsService } from '@services/util/validators.service';
import { map, Observable, startWith } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { EquipoPatronComponent } from '../equipo-patron.component';
@Component({
  selector: 'app-formulario-equipo-patron',
  templateUrl: './formulario-equipo-patron.component.html',
  styleUrls: ['./formulario-equipo-patron.component.scss']
})
export class FormularioEquipoPatronComponent {

  form: FormGroup;
  mostrarBoton: boolean = true;
  title = "Nuevo Patrón";

  codigoEquipoList: CodigoEquipoModel[] = [];
  colaboradorList: Colaborador[] = [];
  departamentoList: DepartamentoModel[] = [];
  marcaList: MarcaModel[] = [];

  codigoEquipoControl = new FormControl<string>('', Validators.required);
  filteredCodigoEquipos$: Observable<CodigoEquipoModel[]>;

  colaboradorControl = new FormControl<string>('', Validators.required);
  filteredColaboradores$: Observable<Colaborador[]>;

  departamentoControl = new FormControl<string>('', Validators.required);
  filteredDepartamento$: Observable<DepartamentoModel[]>;

  marcaControl = new FormControl<string>('', Validators.required);
  filteredMarca$: Observable<MarcaModel[]>;

  constructor(
    private util: Util,
    private changeDetectorRef: ChangeDetectorRef,
    private datePipe: DatePipe,
    private catalogoService: EquipoPatronService,
    private colaboradorService: CatalogoColaboradorService,
    private codigoEquipoService: CatalogoCodigoEquipoService,
    private departamentoService: CatalogoDepartamentoService,
    private marcaService: CatalogoMarcaService,
    public dialogRef: MatDialogRef<FormularioEquipoPatronComponent>,
    private validatorsService: ValidatorsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    if (data.update) {
      this.title = "Modificar Patrón";
    }
    if (data.view) {
      this.title = "Vista Patrón";
    }
  }



  ngOnInit(): void {
    this.buildForm(this.data?.row);
    this.codigoEquipoLista();
    this.colaboradorLista();
    this.departamentoLista();
    this.marcaLista();

    this.filteredColaboradores$ = this.colaboradorControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );

    this.filteredCodigoEquipos$ = this.codigoEquipoControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterCodigoEquipo(value || ''))
    );

    this.filteredDepartamento$ = this.departamentoControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterDepartamento(value || ''))
    );

    this.filteredMarca$ = this.marcaControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterMarca(value || ''))
    );
    if(this.data.update || this.data.view){
      this.calcularSiguienteCalibracion();

    }
  }

  calcularSiguienteCalibracion(){
    this.catalogoService.obtenerSiguienteCalibracion(this.data?.row?.idEquipo).subscribe(
      (data) => {
        console.log(data);
        this.form.get('numeroSemana')?.setValue(data.numeroSemana);
        this.form.get('fechaCalibracion')?.setValue(this.datePipe.transform(data.fechaCalibracion, 'dd-MM-yyyy'));;

      });
  }

  colaboradorLista() {
    this.colaboradorService.getAll().subscribe(data => {
      this.colaboradorList = data;
      if (this.data?.row?.colaborador.idColaborador) {
        const colaboradorSeleccionado = this.colaboradorList.find(
          (col) => col.idColaborador === this.data?.row?.colaborador?.idColaborador
        );
        if (colaboradorSeleccionado) {
          this.colaboradorControl.setValue(
            `${colaboradorSeleccionado.nombre} ${colaboradorSeleccionado.apellidoPaterno} ${colaboradorSeleccionado.apellidoMaterno}`
          );
          this.form.get('idColaborador')?.setValue(colaboradorSeleccionado.idColaborador);
        }
      }
    }, error => {
      this.util.errorMessage("Error al obtener lista de colaboradores.");
    });
  }

  private _filter(value: any): Colaborador[] {
    const filterValue = (value || '').toString().trim().toLowerCase();
  
    return this.colaboradorList.filter(({ nombre, apellidoPaterno, apellidoMaterno, idColaborador }) => {
      const fullName = `${nombre} ${apellidoPaterno} ${apellidoMaterno}`.toLowerCase();
      const idString = idColaborador.toString();
      return fullName.includes(filterValue) || idString.includes(filterValue);
    });
  }
  

  seleccionarColaborador(event: any) {
    const colaboradorSeleccionado = event.option.value;
    if (colaboradorSeleccionado) {
      this.colaboradorControl.setValue(
        `${colaboradorSeleccionado.nombre} ${colaboradorSeleccionado.apellidoPaterno} ${colaboradorSeleccionado.apellidoMaterno}`
      );
      this.form.get('idColaborador')?.setValue(colaboradorSeleccionado.idColaborador);
    }
  }

  abrirAutocomplete() {
    if (!this.colaboradorControl.value) {
      this.colaboradorControl.setValue(' ');
      this.colaboradorControl.setValue('');
    }
  }


  codigoEquipoLista() {
    this.codigoEquipoService.getAll().subscribe(data => {
      this.codigoEquipoList = data;

      if (this.data?.row?.equipo.idCodigoEquipo) {
        const codigoEquipoSeleccionado = this.codigoEquipoList.find(
          (col) => col.idCodigoEquipo === this.data?.row?.equipo.idCodigoEquipo
        );
        if (codigoEquipoSeleccionado) {
          this.codigoEquipoControl.setValue(
            `${codigoEquipoSeleccionado.claveEquipo} ${codigoEquipoSeleccionado.nombreEquipo}`
          );
          this.form.get('idCodigoEquipo')?.setValue(codigoEquipoSeleccionado.idCodigoEquipo);
        }
      }
    }, error => {
      this.util.errorMessage("Error al obtener lista de còdigo de equipos.");
    });
  }

  private _filterCodigoEquipo(value: any): CodigoEquipoModel[] {
    const filterValue = (value || '').toString().trim().toLowerCase();
  
    return this.codigoEquipoList.filter(({ claveEquipo, nombreEquipo, idCodigoEquipo }) => {
      const fullName = `${claveEquipo} ${nombreEquipo}`.toLowerCase();
      const idString = idCodigoEquipo.toString();
      return fullName.includes(filterValue) || idString.includes(filterValue);
    });
  }
  
  seleccionarCodigoEquipo(event: any) {
    const codigoEquipoSeleccionado = event.option.value;
    if (codigoEquipoSeleccionado) {
      this.codigoEquipoControl.setValue(
        `${codigoEquipoSeleccionado.claveEquipo} ${codigoEquipoSeleccionado.nombreEquipo}`
      );
      this.form.get('idCodigoEquipo')?.setValue(codigoEquipoSeleccionado.idCodigoEquipo);
    }
  }

  abrirAutocompleteCodigoEquipo() {
    if (!this.codigoEquipoControl.value) {
      this.codigoEquipoControl.setValue(' ');
      this.codigoEquipoControl.setValue('');
    }
  }

  departamentoLista() {
    this.departamentoService.getAll().subscribe(data => {
      this.departamentoList = data;

      if (this.data?.row?.departamento.idArea) {
        const departamentoSeleccionado = this.departamentoList.find(
          (col) => col.idArea === this.data?.row?.departamento.idArea
        );
        if (departamentoSeleccionado) {
          this.departamentoControl.setValue(
            `${departamentoSeleccionado.nombreArea}`
          );
          this.form.get('idDepartamento')?.setValue(departamentoSeleccionado.idArea);
        }
      }
    }, error => {
      this.util.errorMessage("Error al obtener lista de departamento.");
    });
  }

  private _filterDepartamento(value: any): DepartamentoModel[] {
    const filterValue = (value || '').toString().trim().toLowerCase();
  
    return this.departamentoList.filter(({ nombreArea , idArea}) => {
      const fullName = `${nombreArea}`.toLowerCase();
      const idString = idArea.toString();
      return fullName.includes(filterValue) || idString.includes(filterValue);
    });
  }
  
  seleccionarDepartamento(event: any) {
    const departamentoSeleccionado = event.option.value;
    if (departamentoSeleccionado) {
      this.departamentoControl.setValue(
        `${departamentoSeleccionado.nombreArea}`
      );
      this.form.get('idDepartamento')?.setValue(departamentoSeleccionado.idArea);
    }
  }

  abrirAutocompleteDepartamento() {
    if (!this.departamentoControl.value) {
      this.departamentoControl.setValue(' ');
      this.departamentoControl.setValue('');
    }
  }

  marcaLista() {
    this.marcaService.getAll().subscribe(data => {
      this.marcaList = data;

      if (this.data?.row?.marca.idMarca) {
        const marcaSeleccionada = this.marcaList.find(
          (col) => col.idMarca === this.data?.row?.marca.idMarca
        );
        if (marcaSeleccionada) {
          this.marcaControl.setValue(
            `${marcaSeleccionada.marca}`
          );
          this.form.get('idMarca')?.setValue(marcaSeleccionada.idMarca);
        }
      }
    }, error => {
      this.util.errorMessage("Error al obtener lista de marcas.");
    });
  }

  private _filterMarca(value: any): MarcaModel[] {
    const filterValue = (value || '').toString().trim().toLowerCase();  
    return this.marcaList.filter(({ idMarca , marca}) => {
      const fullName = `${marca}`.toLowerCase();
      const idString = idMarca.toString();
      return fullName.includes(filterValue) || idString.includes(filterValue);
    });
  }
  
  seleccionarMarca(event: any) {
    const marcaSeleccionada = event.option.value;
    if (marcaSeleccionada) {
      this.marcaControl.setValue(
        `${marcaSeleccionada.marca}`
      );
      this.form.get('idMarca')?.setValue(marcaSeleccionada.idMarca);
    }
  }

  abrirAutocompleteMarca() {
    if (!this.marcaControl.value) {
      this.marcaControl.setValue(' ');
      this.marcaControl.setValue('');
    }
  }

  private buildForm(data: EquipoModel): void {
    this.form = new FormGroup({
      idEquipo: new FormControl(data?.idEquipo ?? 0),
      claveInterna: new FormControl(data?.claveInterna ?? '', {
        nonNullable: true, validators: [Validators.required, Validators.maxLength(10)]
      }),
      idCodigoEquipo: new FormControl(data?.equipo.idCodigoEquipo ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.required]
      }),
      modelo: new FormControl(data?.modelo ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(50)]
      }),
      serie: new FormControl(data?.serie ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(50)]
      }),
      idDepartamento: new FormControl(data?.departamento.idArea ?? '', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      localizacion: new FormControl(data?.localizacion ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(70)]
      }),
      idColaborador: new FormControl(data?.colaborador.idColaborador ?? '', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      condAlmacenamiento: new FormControl(data?.condAlmacenamiento ?? '', {
        nonNullable: true,
        validators: [Validators.maxLength(250)]
      }),
      calibFrecuencia: new FormControl(data?.calibFrecuencia ?? '', {
        nonNullable: true,
        validators: [Validators.required,Validators.maxLength(250)]
      }),
      calibApartir: new FormControl(data?.calibApartir ?? '', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      ep: new FormControl({ value: data?.ep ?? 'PATRON', disabled: true}, {
        nonNullable: true,
        validators: [Validators.maxLength(10)]
      }),
      idMarca: new FormControl(data?.marca.idMarca ?? 'PATRON', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      activo: new FormControl(data?.activo ?? true, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      tipCalib: new FormControl({ value: data?.tipCalib ?? 'EXTERNA', disabled: true}, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      numeroSemana: new FormControl({value: 52 ,disabled: true },{
        nonNullable: true
      }),
      fechaCalibracion: new FormControl({value: '' ,disabled: true },{
        nonNullable: true
      }),
    });
    if (this.data.view) {
      this.form.disable();
      this.mostrarBoton = false;
      this.colaboradorControl.disable();
      this.codigoEquipoControl.disable(),
      this.departamentoControl.disable();
      this.marcaControl.disable();
    }

  }


  isValidField(field: string): boolean {
    return this.form?.controls[field]?.invalid && this.form?.controls[field]?.touched;
  }


  getFieldError(field: string): string {
    return this.validatorsService.getFieldError(this.form, field);
  }


  enviar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
console.log();
    const equipo: EquipoModel = this.formToModel();
    const request = this.data.insert
      ? this.catalogoService.create(equipo)
      : this.catalogoService.update(equipo);
      console.log(equipo);

    request.subscribe(response => {
      if (response.success) {
        this.util.successMessage("Registro guardado con éxito!");
        this.dialogRef.close({ data: response });
      } else {
        const errorMsg = this.util.isEmpty(response.message)
          ? "Ocurrió un error al guardar el registro"
          : response.message;
        this.util.errorMessage(errorMsg);
      }
    });
  }


  private formToModel(): EquipoModel {
    const formValues = this.form.getRawValue();
    return {
      idEquipo: formValues.idEquipo,
      claveInterna: formValues.claveInterna,
      modelo: formValues.modelo,
      serie: formValues.serie ,
      localizacion: formValues.localizacion,
      condAlmacenamiento: formValues.condAlmacenamiento,
      calibFrecuencia : formValues.calibFrecuencia,
      calibApartir: formValues.calibApartir,
      ep : formValues.ep,
      activo : formValues.activo,
      tipCalib : formValues.tipCalib,
      equipo: {
        idCodigoEquipo: formValues.idCodigoEquipo
      },
      departamento: {
        idArea: formValues.idDepartamento
      },
      colaborador: {
        idColaborador: formValues.idColaborador
      },
      marca: {
        idMarca: formValues.idMarca
      }
    };
  }
}
